@charset "UTF-8";

/* src/app/modules/accounting/accounting-tabs.component.scss */
.tabla-resultados {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9em;
}
.tabla-resultados th {
  background-color: #e3fd64;
  color: #1a1d23;
  padding: 5px;
}
.tabla-resultados td {
  border: 1px solid #ddd;
  padding: 5px;
}
.tabla-resultados tr:nth-child(even) {
  background-color: #f2f2f2;
}
.ac-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.ac-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.ac-page-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.ac-page-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.ac-page-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: #e3fd64;
}
.ac-page-header__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #1a1d23;
}
.ac-page-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: #6b7280;
}
.ac-page-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.ac-toolbar {
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  border: 1px solid #e5e7eb;
  padding: 20px 20px 12px;
}
.ac-toolbar__fields {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}
:host ::ng-deep .rt-months-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.ac-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}
.ac-btn-primary {
  background-color: #e3fd64 !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
}
.ac-btn-export {
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
}
.ac-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 64px 24px;
}
.ac-loading__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.12);
}
.ac-loading__icon mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: #e3fd64;
}
.ac-loading__dots {
  display: flex;
  gap: 8px;
}
.ac-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #e3fd64;
  opacity: 0.3;
  animation: ac-pulse 1.2s ease-in-out infinite;
}
.ac-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.ac-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.ac-loading__text {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
}
@keyframes ac-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.ac-inline-dots {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: 6px;
}
.ac-inline-dots span {
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #e3fd64;
  opacity: 0.4;
  animation: ac-pulse 1.1s ease-in-out infinite;
}
.ac-inline-dots span:nth-child(2) {
  animation-delay: 0.18s;
}
.ac-inline-dots span:nth-child(3) {
  animation-delay: 0.36s;
}
.ac-table-wrap {
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  border: 1px solid #e5e7eb;
  overflow: hidden;
}
.fin-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
}
.fin-table td {
  padding: 7px 16px;
  border-bottom: 1px solid #f0f0f0;
  color: #1a1d23;
  vertical-align: middle;
}
.fin-table td:last-child {
  text-align: right;
  font-variant-numeric: tabular-nums;
  min-width: 140px;
  white-space: nowrap;
}
.fin-table tr:hover td {
  background: #fef9ec;
}
.fin-table__section td {
  background: rgba(227, 253, 100, 0.06);
  font-weight: 700;
  font-size: 11.5px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #92400e;
  border-bottom: 2px solid rgba(227, 253, 100, 0.2);
}
.fin-table__result td {
  font-weight: 700;
  background: #f3f4f6;
  border-top: 2px solid #e5e7eb;
  border-bottom: 2px solid #e5e7eb;
  color: #1a1d23;
  font-size: 14px;
}
.fin-table__key-result td {
  font-weight: 700;
  background: #1e2235;
  color: rgba(255, 255, 255, 0.92);
  font-size: 14px;
  border-top: 3px solid #e3fd64;
}
.fin-table__key-result td:last-child {
  color: #e3fd64;
}
.fin-table__positive td:last-child {
  color: #16a34a !important;
  font-weight: 600;
}
.fin-table__negative td:last-child {
  color: #dc2626 !important;
  font-weight: 600;
}
.fin-table__sub td:first-child {
  padding-left: 32px;
  color: #6b7280;
  font-size: 13px;
}
.cf-page {
  padding: 24px;
}
.cf-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 80px 24px;
}
.cf-loading__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.12);
}
.cf-loading__icon-wrap mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: #e3fd64;
}
.cf-loading__dots {
  display: flex;
  gap: 8px;
}
.cf-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #e3fd64;
  opacity: 0.3;
  animation: cf-pulse 1.2s ease-in-out infinite;
}
.cf-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.cf-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.cf-loading__text {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
}
@keyframes cf-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.cf-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
}
.cf-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.cf-header__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.cf-header__icon-wrap mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #e3fd64;
}
.cf-header__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #1a1d23;
}
.cf-header__sub {
  margin: 2px 0 0;
  font-size: 13px;
  color: #6b7280;
}
.cf-table-wrap {
  overflow-x: auto;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  border: 1px solid #e5e7eb;
}
.cf-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
  background: #fff;
}
.cf-table .cf-th {
  background: #1e2235;
  color: rgba(255, 255, 255, 0.87);
  padding: 10px 12px;
  text-align: right;
  font-weight: 600;
  white-space: nowrap;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
}
.cf-table .cf-th--label {
  text-align: left;
  min-width: 200px;
  position: sticky;
  left: 0;
  z-index: 2;
  background: #1e2235;
}
.cf-table .cf-td {
  padding: 8px 12px;
  text-align: right;
  border-bottom: 1px solid #f0f0f0;
  border-right: 1px solid #f0f0f0;
  white-space: nowrap;
  color: #374151;
}
.cf-table .cf-td--label {
  text-align: left;
  color: #1a1d23;
  font-weight: 500;
  background: #fafafa;
  position: sticky;
  left: 0;
  z-index: 1;
}
.cf-table .cf-td--section {
  text-align: left;
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--cf-brand-dark, #d48f00);
  background: rgba(227, 253, 100, 0.06);
  padding: 10px 12px;
}
.cf-table .cf-td--total {
  font-weight: 700;
  background: #f3f4f6;
  color: #1a1d23;
}
.cf-table .cf-tr:hover td {
  background-color: #fef9ec;
}
.cf-table .cf-tr--section td {
  border-bottom: 2px solid rgba(227, 253, 100, 0.2);
}
.cf-table .cf-tr--total td {
  border-top: 2px solid #e5e7eb;
  border-bottom: 2px solid #e5e7eb;
}
.cf-table .cf-tr--highlight td {
  background: #f9fafb;
}
.cf-table .cf-tr--result td {
  border-top: 3px solid #e3fd64;
}
.cf-table .cf-positive {
  color: #16a34a !important;
  font-weight: 600;
}
.cf-table .cf-negative {
  color: #dc2626 !important;
  font-weight: 600;
}
/*# sourceMappingURL=accounting-tabs.component.css.map */
